import React from 'react';
import './ExpandableRadioButton.scss';
import { FormControlLabel, Radio } from '@mui/material';

interface ExpandableRadioButtonProps {
    value: any;
    label: string;
    isExpanded: boolean;
    expandableContent: React.JSX.Element | string;
    disabled?: boolean;
    checked?: boolean;
}

const ExpandableRadioButton = (props: ExpandableRadioButtonProps) => {
    return (
        <div className="expandable-radio-button">
            <FormControlLabel
                value={props.value}
                control={<Radio disableRipple={true} size="small" />}
                label={props.label}
                disabled={props.disabled}
            />
            {props.isExpanded && props.expandableContent}
        </div>
    );
};

export default ExpandableRadioButton;
